type DocumentStatus =
  | "ERROR"
  | "UNKNOWN"
  | "GENERAL"
  | "GENERAL_FORMAT"
  | "MULTIPLE"
  | "INVALID"
  | "EMPTY"
  /** a field was extracted with an OCR confidence below the configured threshold */
  | "OCR_WARNING";

/**
 * Order of the DocumentStatus keys are important - the order is used to determine which DocStatus should be rendered
 * when multiple are available.
 */
const documentStatusKeys: DocumentStatus[] = [
  "UNKNOWN",
  "GENERAL",
  "GENERAL_FORMAT",
  "ERROR",
  "MULTIPLE",
  "INVALID",
  "EMPTY",
  "OCR_WARNING",
];
const isDocumentStatus = (value: string): value is DocumentStatus => {
  return documentStatusKeys.indexOf(value as DocumentStatus) > -1;
};

const getDocumentStatuses = () => {
  return [...documentStatusKeys];
};
const getDocumentStatusesDisplayValue = (key: DocumentStatus): string => {
  if (key === "GENERAL_FORMAT") return "General Format";
  if (key === "OCR_WARNING") return "OCR Warning";
  return key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();
};
export {
  DocumentStatus,
  isDocumentStatus,
  getDocumentStatuses,
  getDocumentStatusesDisplayValue,
};
